const isOrderProductOutlet = (orderProduct, outletProductData) => {
  if (orderProduct?.isOutlet === true) {
    return true
  }

  return Boolean(outletProductData && outletProductData.isOutlet !== false)
}

export default isOrderProductOutlet
